import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'phone'})
export class PhonePipe implements PipeTransform {

	transform(value: any, args?: any): any {
		let str = value + '';
		str = str.replace(/\D/g, '');

		if (str.length === 11 ) {
			str = str.replace(/^(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
		} else if (str.length === 13) {
			str = str.replace(/^(\d{2})(\d{2})(\d{5})(\d{4})/, '+$1 ($2) $3-$4');
		} else {
			str = str.replace(/^(\d{2})(\d{4})(\d{4})/, '($1) $2-$3');
		}

		return str;

	}

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/shared/phone.pipe.ts